import React from "react";
import { useLocation } from "react-router-dom";
import "./ListEach.css";
import { MdOutlineBookmarkAdd, MdMoreHoriz, savedToList } from "react-icons/md";
import RightFixed from "../../RightFixed/RightFixed";

export default function ListEach({ newList }) {
  let location = useLocation();
  return (
    <div className="list-each">
      {newList.map((item) => {
        if (item.id === location.pathname.split("/").at(-1)) {
          return (
            <div className="bosh-container">
              <div className="reading-in">
                <div className="avatar-reading">
                  <div className="ava-pic">S</div>
                  <div className="person-info">
                    <h4>Shaxzod Muradov</h4>
                    <p>
                      May 30 <span>2stories</span>
                    </p>
                  </div>
                </div>
                <div>
                  <MdMoreHoriz className="more" />
                </div>
              </div>{" "}
              <h1 className="reading-h1">{item.name}</h1>

              <div className="fix-div"><RightFixed /></div>
            </div>
          );
        }
      })}
    </div>
  );
}
